export enum RangeType {
  DAY = 'daily',
  WEEK = 'weekly',
  MONTH = 'monthly',
  YEAR = 'yearly',
}
